<section class="text-center">
  <app-initiatives-hero *ngIf="selectedInitiative" [title]="selectedInitiative?.title"
                        [backgroundClass]="selectedInitiative?.bgClass"
                        [textClass]="selectedInitiative?.textClass"
                        [imgBannerUrl]="selectedInitiative?.imgBannerUrl"
                        [altImgBanner]="selectedInitiative?.altImgBanner"
                        [subtitle]="selectedInitiative?.subtitle"></app-initiatives-hero>
  <app-initiatives-domain [domain]="domain" [showDomainInfo]="true"></app-initiatives-domain>

  <div class="row justify-content-center py-5 bg-datos">
    <div class="col-12 col-md-6">
      <div class="border-card p-3 my-3 my-lg-0">
        <div class="card-body fs-m p-0">
          <div class="subtitle-primary pb-3 text-uppercase text-start"> {{ "Registrante (Titular)" | translate }} </div>
          <div class="pb-2 font-weight-normal subtitle-primary-regular text-start">
            {{  "Persona que tiene todos los derechos del dominio." | translate }}
          </div>
          <div class="py-1 text-start font-weight-bold">
            {{ "Selecciona la persona o empresa registrante para tu dominio" | translate }}
          </div>
          <!-- Registrant section-->
          <section id="titularComponent">
            <app-contact-selection (onOpenFormClicked)="onShowContactFormClick($event, true, 0)"
                                   (onSelectedContactChange)="onSelectRegistrantContact($event, false)" [contactId]="registrantContactId"
                                   [contacts]="contacts"></app-contact-selection>
          </section>
        </div>
      </div>

      <!-- Checkbox de aceptación -->
      <div class="form-check m-3 text-start d-inline-block">
        <input class="form-check-input checkbox-accepted " type="checkbox" id="acceptPolicies"
               [(ngModel)]="acceptedPolicies">
        <label class="form-check-label mx-2 text-dark" for="acceptPolicies">
          {{'He leído y acepto las' | translate }}
          <a [href]="noticeOfPrivacyURL" class="underline text-green anchor" target="_blank">{{'políticas' | translate }}</a>
          {{'de cada servicio agregado en esta promoción.' | translate }}
        </label>
      </div>

      <!-- Botón de acción -->
      <div class="mt-2">
        <button *ngIf="showButtonRedeem" id="reedemMadeInMexicoButton" type="button" class="btn btn-primary btn-lg text-uppercase"
                (click)="redeem()">
          {{ 'Reclama tus beneficios' | translate }}
        </button>
      </div>
    </div>
  </div>
</section>

<app-dialog [enableCloseDialogButton]="false" [show]="showConfirmationModal" [preventCloseFromBackDrop]="true">
  <app-initiatives-confirm [dudaSetupUrl]="dudaSetupUrl"></app-initiatives-confirm>
</app-dialog>

<!-- Contact data form -->
<app-dialog [enableCloseDialogButton]="false" [show]="showContactForm" [preventCloseFromBackDrop]="true">
  <ng-container *ngIf="showContactForm">
    <app-contact-form [showPersonTypeInformation]="isShowPersonTypeOptions" (onCancel)="showContactForm = false"
                      (onSave)="onContactsUpdated($event)" [contactId]="selectedContactId" [isRegistrantTab]="activeContactTab"
                      [contacts]="contacts"></app-contact-form>
  </ng-container>
</app-dialog>
